import { render, staticRenderFns } from "./relation-list-obj.vue?vue&type=template&id=00061035&scoped=true&"
import script from "./relation-list-obj.vue?vue&type=script&lang=js&"
export * from "./relation-list-obj.vue?vue&type=script&lang=js&"
import style0 from "./relation-list-obj.vue?vue&type=style&index=0&id=00061035&prod&scoped=true&lang=scss&"
import style1 from "./relation-list-obj.vue?vue&type=style&index=1&id=00061035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00061035",
  null
  
)

export default component.exports